import FileNameDto from 'modules/base/dto/file/FileNameDto';

export class FmDirectoryCurrentDto extends FileNameDto {
	/**
	 * @module FmDirectoryCurrentDto
	 */
	constructor() {
		super();
		/** @type {FileNameDto} */
		this.parentDirectory = null;
		/** @type {FileNameDto} */
		this.parentStorage = null;
	}

	/**
	 * @typedef {Object} _FmDirectoryCurrentDto
	 * @property {FileNameDto} parentDirectory
	 * @property {FileNameDto} parentStorage
	 * @typedef {import("./IdentifiableDto").IdentifiableDtoProps & _FmDirectoryCurrentDto} FmDirectoryCurrentDto
	 */
	/**
	 *
	 * @param {FmDirectoryCurrentDto} props
	 * @returns {FmDirectoryParentDto}
	 */
	setup(props) {
		super.setup(props);
		this.parentDirectory = props.parentDirectory;
		this.parentStorage = props.parentStorage;
		return this;
	}
}

export default FmDirectoryCurrentDto;
